
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipe/[autor]",
      function () {
        return require("private-next-pages/equipe/[autor]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipe/[autor]"])
      });
    }
  